export const DOC = {};


//-------------------------------------------------------------------
DOC.UPDATE_WAITING_CONTRACT_SUBJECT_LIST =
  "UPDATE_WAITING_CONTRACT_SUBJECT_LIST";
//-------------------------------------------------------------------
DOC.UPDATET_DOC_LIST = "UPDATET_DOC_LIST";
//-------------------------------------------------------------------
DOC.ADD_NEW_DOC ="ADD_NEW_DOC"
//-------------------------------------------------------------------
DOC.UPDATE_DOC_GROUP ="UPDATE_DOC_GROUP"
//-------------------------------------------------------------------
DOC.EDIT_DOC ="EDIT_DOC"
//-------------------------------------------------------------------
DOC.FILTER_DOC_LIST ="FILTER_DOC_LIST"
//-------------------------------------------------------------------
DOC.ISFILTERED_DOC_LIST="ISFILTERED_DOC_LIST"
//-------------------------------------------------------------------
DOC.UPDATE_SELECTED_DOC="UPDATE_SELECTED_DOC"
//-------------------------------------------------------------------
DOC.ADD_NEW_REVISION ="ADD_NEW_REVISION"
//-------------------------------------------------------------------
DOC.UPDATE_DOC_INPROGRESS_LIST ="UPDATE_DOC_INPROGRESS_LIST"
//-------------------------------------------------------------------
DOC.UPDATE_SELECTED_REV ="UPDATE_SELECTED_REV"
//-------------------------------------------------------------------
DOC.RESET_REV_STATE ="RESET_REV_STATE"
//-------------------------------------------------------------------
DOC.UPDATE_REV_ACTIVITY ="UPDATE_REV_ACTIVITY"
//-------------------------------------------------------------------
DOC.UPDATE_SELECTED_ACTIVITY ="UPDATE_SELECTED_ACTIVITY"
//-------------------------------------------------------------------
DOC.CLOSE_TIMESHEET_MODAL ="CLOSE_TIMESHEET_MODAL"
//-------------------------------------------------------------------
DOC.OPEN_FINALIZING_MODAL ="OPEN_FINALIZING_MODAL"
//-------------------------------------------------------------------
DOC.UPDATE_USER_LIST ="UPDATE_USER_LIST"
//------------------------------------------------------------------
DOC.UPDATE_SELECTED_PENDING_REV ="UPDATE_SELECTED_PENDING_REV"
//-------------------------------------------------------------------
DOC.OPEN_PENDING_REV_MODAL ="OPEN_PENDING_REV_MODAL"
//-------------------------------------------------------------------
DOC.VIEW_DOC_ARCHIVE="VIEW_DOC_ARCHIVE"
//-------------------------------------------------------------------
DOC.VIEW_DOC_HISTORY = "VIEW_DOC_HISTORY"
//-------------------------------------------------------------------
DOC.TOGGLE_REV_EDIT_MODAL = "TOGGLE_REV_EDIT_MODAL"

